"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInputBase = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const debug_1 = __importDefault(require("debug"));
const vue_property_decorator_1 = require("vue-property-decorator");
const imask_1 = __importDefault(require("imask"));
const log = (0, debug_1.default)('itp:ui:components:forms:form-input-base');
let FormInputBase = class FormInputBase extends vue_1.default {
    currentValue;
    validationState;
    componentContext;
    formContext;
    $refs;
    imask;
    id;
    vid;
    name;
    mask;
    value;
    rules;
    form;
    autofocus;
    disabled;
    readonly;
    required;
    placeholder;
    label;
    labelFor;
    size;
    debounce;
    scale;
    unmask;
    min;
    max;
    data() {
        return {
            ...this.hackData(),
            currentValue: this.parseValue(this.value),
            validationState: {
                state: null,
                errors: []
            }
        };
    }
    hackData() {
        return {};
    }
    onValueChanged(value, old) {
        if (value == old) {
            return;
        }
        log('prop:value[%s] changed from %o to %o', this.name, old, value);
        if (this.imask) {
            if (value !== this.getIMaskValue()) {
                this.updateMaskValue();
            }
        }
        else {
            this.currentValue = this.parseValue(value);
        }
    }
    onCurrentValueChanged(value, old) {
        if (value == old) {
            return;
        }
        log('prop:currentValue[%s] changed from %o to %o', this.name, old, value);
        if (this.imask) {
            this.$emit('input', this.getIMaskValue());
        }
        else {
            this.$emit('input', this.dumpValue(value));
        }
    }
    onMaskChanged() {
        this.updateInputMaskOptions();
    }
    onUnmaskChanged() {
        this.updateInputMaskOptions();
    }
    onScaleChanged() {
        this.updateInputMaskOptions();
    }
    onMinChanged() {
        this.updateInputMaskOptions();
    }
    onMaxChanged() {
        this.updateInputMaskOptions();
    }
    get isReadonly() {
        return this.readonly || (this.formContext && this.formContext.readonly);
    }
    get isDisabled() {
        return this.disabled || (this.formContext && this.formContext.disabled);
    }
    get isReadonlyOrDisabled() {
        return (this.disabled ||
            this.readonly ||
            (this.formContext &&
                (this.formContext.disabled || this.formContext.readonly)));
    }
    get validationRules() {
        if (this.required) {
            return 'required';
        }
    }
    parseValue(value) {
        return value;
    }
    dumpValue(value) {
        return value;
    }
    getValidationState(p) {
        const state = p.dirty ? (p.validated ? p.valid : null) : null;
        this.dispatchValidated(state, p.errors);
        return state === true ? null : state;
    }
    dispatchValidated(state, errors, force = false) {
    }
    mounted() {
        this.componentContext.$on('form:validated', (e) => {
            if (this.form === e.id && this.name in Object.keys(e.errors)) {
                const errors = e.errors[this.name], state = errors.length ? false : null;
                this.dispatchValidated(state, errors, true);
            }
        });
        this.setupInputMask();
    }
    beforeDestroy() {
        this.componentContext.$off('form:validated');
    }
    destroyed() {
        if (this.imask) {
            this.imask.destroy();
            delete this.imask;
        }
    }
    cancelChange() {
        if (this.componentContext.cancelChange(this.name)) {
            this.$refs.validator.validate();
        }
    }
    onBlur() {
        this.$emit('blur');
    }
    setupInputMask() {
        const options = this.getInputMaskOptions();
        if (options) {
            this.setupMask(options);
        }
    }
    updateInputMaskOptions() {
        if (!this.imask) {
            return;
        }
        const options = this.getInputMaskOptions();
        if (options) {
            this.imask.updateOptions(options);
        }
    }
    getInputMaskOptions() {
        const isNumber = this.mask === 'number';
        return isNumber ? this.getInputMaskNumberOptions() : null;
    }
    getInputMaskNumberOptions() {
        let result = {
            mask: Number,
            thousandsSeparator: ' ',
            padFractionalZeros: false,
            normalizeZeros: true,
            radix: ',',
            mapToRadix: ['.'],
            autofix: true,
            scale: coerceToNumber(this.scale)
        };
        if (this.min != null) {
            result['min'] = coerceToNumber(this.min);
        }
        if (this.min != null) {
            result['max'] = coerceToNumber(this.max);
        }
        return result;
    }
    setupMask(options) {
        const el = this.$refs.input;
        if (!el) {
            return;
        }
        this.imask = (0, imask_1.default)(el.$el, options)
            .on('accept', this.onMaskAccept.bind(this))
            .on('complete', this.onMaskComplete.bind(this));
        this.updateMaskValue();
        this.currentValue = this.imask.value;
    }
    onMaskAccept() {
        const val = this.getIMaskValue();
        this.$emit('input', val);
        this.$emit('accept', val);
    }
    onMaskComplete() {
        const val = this.getIMaskValue();
        this.$emit('complete', val);
    }
    getIMaskValue() {
        if (this.unmask === 'typed') {
            return this.imask?.typedValue;
        }
        if (this.unmask) {
            return this.imask?.unmaskedValue;
        }
        return this.imask?.value;
    }
    updateMaskValue() {
        if (!this.imask) {
            return;
        }
        const imask = this.imask;
        const value = this.value == null && this.unmask !== 'typed' ? '' : this.value;
        if (this.unmask === 'typed') {
            imask.typedValue = value == null ? '' : value;
            return;
        }
        if (this.unmask) {
            imask.unmaskedValue = value;
            return;
        }
        imask.value = value;
    }
};
exports.FormInputBase = FormInputBase;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], FormInputBase.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], FormInputBase.prototype, "vid", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", String)
], FormInputBase.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], FormInputBase.prototype, "mask", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], FormInputBase.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], FormInputBase.prototype, "rules", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], FormInputBase.prototype, "form", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], FormInputBase.prototype, "autofocus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], FormInputBase.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], FormInputBase.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], FormInputBase.prototype, "required", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String }),
    __metadata("design:type", String)
], FormInputBase.prototype, "placeholder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], FormInputBase.prototype, "label", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], FormInputBase.prototype, "labelFor", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'md' }),
    __metadata("design:type", String)
], FormInputBase.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 0 }),
    __metadata("design:type", Object)
], FormInputBase.prototype, "debounce", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 0 }),
    __metadata("design:type", Object)
], FormInputBase.prototype, "scale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], FormInputBase.prototype, "unmask", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], FormInputBase.prototype, "min", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], FormInputBase.prototype, "max", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FormInputBase.prototype, "onValueChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentValue'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FormInputBase.prototype, "onCurrentValueChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('mask'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormInputBase.prototype, "onMaskChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('unmask'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormInputBase.prototype, "onUnmaskChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('scale'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormInputBase.prototype, "onScaleChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('min'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormInputBase.prototype, "onMinChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('max'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormInputBase.prototype, "onMaxChanged", null);
exports.FormInputBase = FormInputBase = __decorate([
    vue_property_decorator_1.Component
], FormInputBase);
function coerceToNumber(value) {
    if (_.isString(value)) {
        value = _.toNumber(value);
    }
    if (_.isNumber(value)) {
        return value;
    }
}
//# sourceMappingURL=form-input-base.js.map